/*
=========================================================
* RingFoods Integrations Section
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";

// @mui icons
import PhoneIcon from "@mui/icons-material/Phone";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import { brandPrimary } from "pages/RingFoodsHomepage/theme";

function Integrations() {
  const integrations = [
    { name: "Google Calendar", icon: CalendarTodayIcon, color: "#4285F4" },
    { name: "Twilio", icon: PhoneIcon, color: "#F22F46" },
    { name: "Gmail", icon: EmailIcon, color: "#EA4335" },
    { name: "SMS", icon: SmsIcon, color: "#34A853" },
    { name: "Square POS", icon: RestaurantMenuIcon, color: "#3E4348" },
    { name: "Clover POS", icon: RestaurantMenuIcon, color: "#228800" },
    { name: "Toast POS", icon: RestaurantMenuIcon, color: "#FF4C00" },
    { name: "Lightspeed POS", icon: RestaurantMenuIcon, color: "#E6312B" },
    { name: "OpenTable", icon: CalendarTodayIcon, color: "#DA3743" },
    { name: "Menu OCR", icon: CameraAltIcon, color: "#10a37f" },
  ];

  return (
    <MKBox component="section" py={{ xs: 8, md: 10 }} id="integrations">
      <Container>
        {/* Section Header */}
        <Grid container spacing={3} sx={{ mb: { xs: 4, md: 6 } }}>
          <Grid item xs={12} lg={8} mx="auto" textAlign="center">
            <MKTypography
              variant="h2"
              fontWeight="bold"
              color="primary"
              sx={{ mb: 2, fontSize: { xs: "1.85rem", sm: "2.25rem", md: "2.5rem" } }}
            >
              Works With What You Already Use
            </MKTypography>
            <MKTypography variant="body1" color="text" sx={{ fontSize: { xs: "1rem", md: "1.125rem" } }}>
              No complex configurations. Most integrations connect in under 5 minutes.
            </MKTypography>
          </Grid>
        </Grid>

        {/* Integration Icons Grid */}
        <Grid container spacing={3} justifyContent="center" sx={{ mb: { xs: 4, md: 6 } }}>
          {integrations.map((item, index) => {
            const Icon = item.icon;
            return (
              <Grid item xs={4} sm={3} md key={index}>
                <MKBox
                  sx={{
                    textAlign: "center",
                    p: { xs: 2, md: 3 },
                    borderRadius: 2,
                    backgroundColor: "white",
                    border: "1px solid #E5E5E5",
                    transition: "all 0.3s ease",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                      borderColor: item.color,
                    },
                  }}
                >
                  <MKBox
                    sx={{
                      width: { xs: 44, md: 56 },
                      height: { xs: 44, md: 56 },
                      borderRadius: "50%",
                      backgroundColor: `${item.color}12`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 1.5,
                    }}
                  >
                    <Icon sx={{ fontSize: { xs: 22, md: 28 }, color: item.color }} />
                  </MKBox>
                  <MKTypography
                    variant="body2"
                    fontWeight={600}
                    sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" }, lineHeight: 1.3 }}
                  >
                    {item.name}
                  </MKTypography>
                  {item.comingSoon && (
                    <Chip
                      label="Soon"
                      size="small"
                      sx={{
                        mt: 0.5,
                        height: 18,
                        fontSize: "0.6rem",
                        backgroundColor: "rgba(26, 26, 26, 0.06)",
                        color: brandPrimary,
                        fontWeight: 600,
                      }}
                    />
                  )}
                </MKBox>
              </Grid>
            );
          })}
        </Grid>

        {/* Request Integration */}
        <Grid container justifyContent="center">
          <Grid item xs={12} textAlign="center">
            <MKTypography variant="body2" color="text" sx={{ opacity: 0.7, mb: 2 }}>
              Need a different integration? We add new ones every month based on customer requests.
            </MKTypography>
            <MKButton
              variant="outlined"
              size="small"
              component="a"
              href="mailto:support@ringfoods.com?subject=Integration%20Request"
              sx={{
                borderColor: "#1A1A1A !important",
                color: "#1A1A1A !important",
                fontWeight: 600,
                "&:hover": {
                  borderColor: "#1A1A1A !important",
                  backgroundColor: "rgba(26, 26, 26, 0.05)",
                },
              }}
            >
              Request Integration
            </MKButton>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Integrations;
